<template>
<div class="c-o-company-section c-o-company-section--presentation" id="presentation">
    <div class="c-o-company-section__inner">
        <div class="c-o-company-section__main">
            <div class="c-o-company-section__logo"  v-if="getLogo">
                <img :src="getLogo" :alt="`Bild på ${company.Name}`"/>
            </div>
            <p v-if="company.Presentation" class="c-o-company-section__body">{{company.Presentation}}</p>
            <div v-if="presentationHtml" class="c-o-company-section__body" v-html="presentationHtml"></div>
        </div>
        <div class="c-o-company-section__sidebar">
            <div class="c-o-company-section__sidebar-block">
                <h3 class="c-o-company-section__sidebar-title">{{company.Name}}</h3>
                <div class="c-o-company-section__sidebar-content">
                    <h4> Företagsuppgifter </h4>

                    <table>
                        <tr v-if="company.OrgNr">
                            <th>Organisationsnummer:</th>
                            <td>{{getOrgNr}}</td>
                        </tr>
                        <tr v-if="company.Quality.HasTaxRegistration">
                            <th>Innehar F-skattesedel:</th>
                            <td>{{convertBoolean(company.Quality.HasTaxRegistration)}}</td>
                        </tr>

                        <tr v-if="company.Quality.Branch">
                            <th>Bransch:</th>
                            <td>{{company.Quality.Branch}}</td>
                        </tr>
                        <tr v-if="company.Quality.RegistrationDate">
                            <th>Registreringsdatum firma:</th>
                            <td>{{company.Quality.RegistrationDate | formatDateWithoutTime}}</td>
                        </tr>
                        <tr v-if="company.Quality.HasVATRegistration">
                            <th>Registrerad för moms:</th>
                            <td>{{convertBoolean(company.Quality.HasVATRegistration)}}</td>
                        </tr>
                        <tr v-if="company.Quality.CompanyForm">
                            <th>Bolagsform:</th>
                            <td>{{company.Quality.CompanyForm}}</td>
                        </tr>
                    </table>

                </div>
                <div class="c-o-company-section__sidebar-content">
                    <h4> Ansvarsförsäkring och kreditvärdighet </h4>

                    <table>
                        <tr v-if="company.Quality.HasInsurance">
                            <th>Ansvarsförsäkring:</th>
                            <td>{{convertBoolean(company.Quality.HasInsurance)}}</td>
                        </tr>
                        <tr v-if="company.Quality.InsuranceCompany">
                            <th>Försäkringsbolag:</th>
                            <td>{{company.Quality.InsuranceCompany}}</td>
                        </tr>
                        <tr>
                            <th>Bevakas via:</th>
                            <td>Creditsafe</td>
                        </tr>
                        <tr>
                            <th>Kreditkontroll:</th>
                            <td>Kreditbevakas löpande, stängs av vid betalningsproblem</td>
                        </tr>
                    </table>

                </div>
                <div class="c-o-company-section__sidebar-content">
                    <h4> Svartlistning </h4>

                    <table>
                        <tr>
                            <th>BraByggare:</th>
                            <td>Ej svartlistad</td>
                        </tr>
                        <tr>
                            <th>Råd och Rön:</th>
                            <td>Ej svartlistad</td>
                        </tr>
                        <tr>
                            <td><a target="_blank" :href="'https://www.radron.se/Svarta-listan/'">Gå till Råd & Röns svartlista</a></td>
                        </tr>
                    </table>
                </div>
            </div>

        </div>
    </div>

</div>
</template>
<script>
import Filters from '../../../../filters/index.js'

import {
    stripScriptTags
} from './../../../../helpers'

export default {
    props: {
        company: Object
    },
    filters: Filters,
    computed: {
        presentationHtml: function() {
            if (this.company.PresentationHtml) {
                return stripScriptTags(this.company.PresentationHtml);
            } else {
                return '&nbsp;';
            }
        },
        getLogo: function() {
            if (this.company.Logo) {
                return this.company.Logo;
            }
        },
        getOrgNr: function() {

            if (this.company.OrgNr && this.company.Quality.CompanyForm === 'Enskild firma') {
                return this.company.OrgNr.substr(0, this.company.OrgNr.length - 4) + '****';
            } else if(this.company.OrgNr) {
                return this.company.OrgNr
            }

        }
    },
    methods: {
        convertBoolean: function(bool) {
            return bool ? 'Ja' : 'Nej'
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/company-sections/OrganismCompanySectionPresentation.vue